import { startTransition } from "react";
import { useNavigate } from "react-router-dom";
import {
  PLATFORM_RESET,
  USER_SET,
  usePlatformDispatch,
} from "@platform//PlatformContext";
import { useRedirectWhenNoInvitation } from "../../hooks/useRedirectWhenNoInvitation";
import { OnboardingSignup } from "./OnboardingSignup";
import { useOnboardingStep } from "../../hooks/useOnboardingStep";
import { useOnboarding } from "../../OnboardingContext";

export function OnboardingSignupContainer() {
  const dispatch = usePlatformDispatch();

  const navigate = useNavigate();

  const { invitation } = useOnboarding();

  const { completeStep } = useOnboardingStep();

  useRedirectWhenNoInvitation();

  const handleSuccessfulSignup = (data: any) => {
    startTransition(() => {
      dispatch({
        type: USER_SET,
        payload: { user: data.userData, authToken: data.authToken },
      });

      completeStep("signup");

      navigate("/youre-in");
    });
  };

  const handleError = () => {
    dispatch({ type: PLATFORM_RESET });
  };

  return (
    <OnboardingSignup
      onSuccess={handleSuccessfulSignup}
      onError={handleError}
      invitation={invitation}
    />
  );
}

export default OnboardingSignupContainer;
